import React from 'react';
import { Translate } from 'react-localize-redux';
import { withLocalize } from "react-localize-redux";
import Semaphore from './semaphore';
import AmlEntityData from './amlEntityData';
import OldStyleSection from '../../common/oldStyleSection';
import AmlCandidatesFilter from './amlCandidatesFilter';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import RelationLink from '../relations/relationLink';

class AmlCompanyEval extends React.Component {
    render() {
        return (
            <OldStyleSection name={this.props.translate("Report.Aml.Subjects.Company")} hasData={this.props.data && this.props.data.length > 0} isOpen isBold>
                <AmlCandidatesFilter section={this.props.section} hideRatioFilter={this.props.hideRatioFilter} />
                <OldStyleTableWithHistory tableColumns={3} stripped
                    head={() => this.renderHead()}
                    actualData={this.props.data}
                    actualRow={(r) => this.renderRow(r)}
                />
            </OldStyleSection>
        );
    }

    renderHead = () => {
        return (
            <thead className="aml-related-subjects-header">
                <tr>
                    <th><Translate id="Report.Aml.Subjects.MainName" /></th>
                    <th><Translate id="Report.Aml.Subjects.Ico" /></th>
                    <th className="col-aml">AML</th>
                </tr>
            </thead>
        );
    }

    renderRow = (r) => {
        return (
            <React.Fragment key={r.key}>
                <tr className='colorize'>
                    <td style={{ fontWeight: "bold" }}><RelationLink wrap entityName={r.name} entityId={r.entityId} reports={r.reports} customPrefix={<></>} showOnMobile={true} /></td>
                    <td>{r.id}</td>
                    <td style={{ textAlign: "center" }}><Semaphore color={r.decision} width={20} height={20} /></td>
                </tr>
                {r.candidates && r.candidates.length > 0 && <tr>
                    <td className="nested-table" colSpan={3}>
                        <AmlEntityData candidates={r.candidates} section={this.props.section} />
                    </td>
                </tr>}
            </React.Fragment>
        );
    }
}

export default withLocalize(AmlCompanyEval);